// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"f1a30c25","186":"6bf1e390","272":"735572ba","372":"094ff098","738":"743c5b04","841":"920188f6","851":"6559de45","856":"9908b4e7"}[chunkId] + ".chunk.js";
};